import { render, staticRenderFns } from "./mutiCard.vue?vue&type=template&id=45d287bf&scoped=true"
import script from "./mutiCard.vue?vue&type=script&lang=js"
export * from "./mutiCard.vue?vue&type=script&lang=js"
import style0 from "./mutiCard.vue?vue&type=style&index=0&id=45d287bf&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d287bf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45d287bf')) {
      api.createRecord('45d287bf', component.options)
    } else {
      api.reload('45d287bf', component.options)
    }
    module.hot.accept("./mutiCard.vue?vue&type=template&id=45d287bf&scoped=true", function () {
      api.rerender('45d287bf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/index/components/mutiCard.vue"
export default component.exports